import React, { Component } from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import { getQueryParams } from '../../../../lib/facetHelpers';
import DataCutsList from './DataCutsList/DataCutsList';
import Placeholder from 'ps-components/Placeholder/Placeholder';
import SubHeaderSearch from '../../../JobMatching/ResultDetails/SubHeaderSearch';
import Pagination from 'ps-components/Pagination/Pagination';
import './DataCutsListPanel.scss';

const ENTER_KEY = 13;
const STEP = 50;
class DataCutsListPanel extends Component {
  static propTypes = {
    addDataCutToRule: func,
    clearSearch: func,
    dataCuts: arrayOf(
      shape({
        currency: shape({
          code: string
        }),
        id: string,
        name: string,
        survey: shape({
          code: string,
          id: string,
          name: string
        })
      })
    ),
    deleteDataCutFromRule: func,
    isLoaded: bool,
    isLoading: bool,
    isSelected: bool,
    pageDataCuts: func,
    search: func,
    searchInputSearch: func,
    searchText: string,
    selectedRuleConnection: arrayOf(
      shape({
        currency: shape({
          code: string
        }),
        id: string,
        name: string,
        survey: shape({
          code: string,
          id: string,
          name: string
        })
      })
    ),
    setSearchText: func,
    toggleShowSelected: func,
    totalDataCutCount: number,
    updateDataCutToRule: func,
    offset: number
  };

  constructor(props) {
    super(props);
    this.getDataCutCurrency = this.getDataCutCurrency.bind(this);
    this.getDataCutId = this.getDataCutId.bind(this);
    this.getDataCutName = this.getDataCutName.bind(this);
    this.getDataCutPriority = this.getDataCutPriority.bind(this);
    this.isDataCutSelected = this.isDataCutSelected.bind(this);
    this.renderPagination = this.renderPagination.bind(this);
    this.renderTable = this.renderTable.bind(this);
  }

  getDataCutCurrency = dataCut => {
    return dataCut.currency.code;
  };

  getDataCutId = dataCut => {
    return dataCut.id;
  };

  getDataCutName = dataCut => {
    return (
      <React.Fragment>
        <div className="datacut__name">{dataCut.name}</div>
        <div className="datacut__survey-name">{dataCut.survey.name}</div>
        <div className="datacut__survey-code">{dataCut.survey.code}</div>
      </React.Fragment>
    );
  };

  getDataCutPriority = dataCut => {
    const { selectedRuleConnection } = this.props;
    const connection = selectedRuleConnection.find(c => c.dataCut.id === dataCut.id);
    if (!connection) return;
    else {
      return connection.priority;
    }
  };

  isDataCutSelected = dataCut => {
    const { selectedRuleConnection } = this.props;
    return selectedRuleConnection.find(c => c.dataCut.id === dataCut.id) !== undefined;
  };

  sortDataCuts = () => {
    const { selectedRuleConnection } = this.props;

    return selectedRuleConnection
      .map(datum => {
        return datum;
      })
      .sort((a, b) => {
        if (a.priority < b.priority) return -1;
        if (a.priority > b.priority) return 1;
        if (a.dataCut.name > b.dataCut.name) return -1;
        if (a.dataCut.name < b.dataCut.name) return 1;
        if (a.dataCut.currency.code > b.dataCut.currency.code) return -1;
        if (a.dataCut.currency.code < b.dataCut.currency.code) return 1;
        return 0;
      })
      .map(item => {
        return item.dataCut;
      });
  };

  searchByText = e => {
    const { search, isSelected, searchInputSearch, searchText } = this.props;

    if (e.keyCode === ENTER_KEY && isSelected) {
      searchInputSearch(searchText);
    }
  };

  renderPagination() {
 
    const { isSelected, dataCuts, totalDataCutCount, pageDataCuts, offset } = this.props;
    const shouldShowMore = dataCuts.length % STEP === 0 && dataCuts.length !== totalDataCutCount;
    if (!isSelected) return;
    return (
      <Pagination
        className="dataCuts__pagination"
        isSelected={isSelected}
        pageAction={pageDataCuts}
        shouldShowInput={true}
        shouldShowMore={shouldShowMore}
        shouldShowRanges={true}
        step={STEP}
        offset={offset}
        totalCount={totalDataCutCount}
      />
    );
  }

  renderTable() {
    const {
      addDataCutToRule,
      dataCuts,
      deleteDataCutFromRule,
      isLoaded,
      isLoading,
      isSelected,
      selectedRuleConnection,
      toggleShowSelected,
      totalDataCutCount,
      updateDataCutToRule
    } = this.props;
    const datacutsToRender = isSelected ? dataCuts : this.sortDataCuts();

    if (datacutsToRender.length) {
      return (
        <DataCutsList
          updateDataCutSelection={addDataCutToRule}
          updateDataCutPriority={updateDataCutToRule}
          dataCuts={datacutsToRender}
          deleteDataCutFromRule={deleteDataCutFromRule}
          isLoaded={isLoaded}
          isLoading={isLoading}
          isSelected={isSelected}
          selectedRuleConnection={selectedRuleConnection}
          toggleShowSelected={toggleShowSelected}
          totalDataCutCount={totalDataCutCount}
          getDataCutId={this.getDataCutId}
          getDataCutName={this.getDataCutName}
          getDataCutCurrency={this.getDataCutCurrency}
          getDataCutPriority={this.getDataCutPriority}
          isDataCutSelected={this.isDataCutSelected}
        />
      );
    } else {
      return (
        <Placeholder
          className="datacuts__empty"
          imagePath="/view/static/mp/images/empty_results.svg"
          secondaryText={
            datacutsToRender.length === 0 && isSelected
              ? 'There are no results for your search.'
              : 'You have not selected any datacuts for this rule.'
          }
          showText={datacutsToRender.length === 0}
        />
      );
    }
  }

  render() {
    const {
      clearSearch,
      dataCuts,
      isSelected,
      selectedRuleConnection,
      toggleShowSelected,
      totalDataCutCount,
      searchText,
      setSearchText
    } = this.props;

    return (
      <div className="datacuts">
        <div className="datacuts__list-header">
          <div className="datacuts__notes">Select data cuts for this rule</div>
          <SubHeaderSearch
            clearSearch={clearSearch}
            isSelected={isSelected}
            placeholderText="Search all data cuts"
            searchId="datacuts__search"
            searchByText={this.searchByText}
            searchText={searchText}
            selectedItems={selectedRuleConnection}
            setSearchText={setSearchText}
            toggleSelected={toggleShowSelected}
            totalCount={totalDataCutCount}
          />
        </div>
        {this.renderTable()}
        {this.renderPagination()}
      </div>
    );
  }
}

export default DataCutsListPanel;
